module.exports = __webpack_public_path__ + "media/images/svg/go-to-420ec426e7ab9d7d0561f8097a2095b9.svg";